module.exports = "/src/views/games/other/images/roles/unknown.png";